import SkillCard from "./SkillCard";

const skillCategories = [
  {
    label: "Frontend",
    skills: [
      { imgSrc: "icons/js.svg", label: "JavaScript", desc: "Interaction" },
      {
        imgSrc: "icons/typescript.svg",
        label: "TypeScript",
        desc: "Interaction",
      },
      { imgSrc: "icons/react.svg", label: "React", desc: "JavaScript library" },
      {
        imgSrc: "icons/tailwind.svg",
        label: "Tailwind",
        desc: "User Interface",
      },
      { imgSrc: "icons/next.svg", label: "NextJS", desc: "Interaction" },
      { imgSrc: "icons/figma.svg", label: "Figma", desc: "Design tool" },
    ],
  },
  {
    label: "Backend",
    skills: [
      { imgSrc: "icons/nodejs.svg", label: "NodeJS", desc: "Web server" },
      {
        imgSrc: "icons/express.svg",
        label: "ExpressJS",
        desc: "Node Framework",
      },
      { imgSrc: "icons/php.svg", label: "PHP", desc: "Backend language" },
      {
        imgSrc: "icons/laravel.svg",
        label: "Laravel",
        desc: "Backend framework",
      },
      {
        imgSrc: "icons/django.svg",
        label: "Django",
        desc: "Backend framework",
      },
    ],
  },
  {
    label: "Database",
    skills: [
      {
        imgSrc: "icons/mysql.svg",
        label: "MySQL",
        desc: "Relational Database",
      },
      {
        imgSrc: "icons/postgresql.svg",
        label: "PostgreSQL",
        desc: "Relational Database",
      },
      { imgSrc: "icons/mongodb.svg", label: "MongoDB", desc: "NoSQL Database" },
      { imgSrc: "icons/redis.svg", label: "Redis", desc: "In-Memory Database" },
    ],
  },
  {
    label: "Tools",
    skills: [
      { imgSrc: "icons/git.svg", label: "Git", desc: "Version control" },
      { imgSrc: "icons/github.svg", label: "GitHub", desc: "CI/CD" },
      { imgSrc: "icons/docker.svg", label: "Docker", desc: "Containerization" },
    ],
  },
];

const Skill = () => {
  return (
    <section id="tools" className="section">
      <div className="container">
        <h2 className="headline-2 reveal-up">Essential Tools I Use</h2>
        <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch] reveal-up">
          Discover the powerful tools and technologies I use to create
          exceptional, high-performing websites and applications.
        </p>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {skillCategories.map(({ label, skills }) => (
            <div key={label} className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-zinc-100 reveal-up">
                {label}
              </h3>
              <div className="flex flex-col gap-3">
                {skills.map(({ imgSrc, label: skillLabel, desc }) => (
                  <SkillCard
                    key={skillLabel}
                    imgSrc={imgSrc}
                    label={skillLabel}
                    desc={desc}
                    classes=" reveal-up"
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skill;
